import { render, staticRenderFns } from "./ImsArbsList.vue?vue&type=template&id=76004c2f&scoped=true&"
import script from "./ImsArbsList.vue?vue&type=script&lang=js&"
export * from "./ImsArbsList.vue?vue&type=script&lang=js&"
import style0 from "./ImsArbsList.vue?vue&type=style&index=0&id=76004c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76004c2f",
  null
  
)

export default component.exports